.container {
  display: flex;
  justify-content: center;
  z-index: 50;
  border-top: 1px solid #c1b9b9;
  margin-top: 16px;
  gap: 16px;
  padding: 15px;
}

.tabsRoot {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tab {
  text-align: center;
  background-color: transparent;
  border: none;
  font-weight: 500;
  color: #948a8a;
}

.tab div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tab[data-active="true"] {
  background-color: transparent;
  color: #e1261c;
  border-bottom: 2px solid #e1261c;
}

.tab[data-active="true"] path {
  stroke: red !important;
}
.tab:hover {
  background-color: transparent;
}

.tabLabel {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 5px;
}

.tabsList {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  gap: 16px;
  border: none;
  padding: 10px;
  background-color: #e1261c;
}

.tab:hover {
  background-color: rgba(255, 0, 0, 0.1);
}
